import React, { useState, useRef, useEffect } from "react";
import "./capcha.scss";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { setCaptcha } from "../../store/captchaSelector";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";

const Item = styled(Box)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));
const But = styled(Button)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));
const Captcha = () => {
  const [captchaText, setCaptchaText] = useState("");
  const [userInput, setUserInput] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const canvasRef = useRef(null);
  const dispatch = useDispatch();
  const captchaSelect = useSelector((state) => state.captchaSelector.captcha);
  const [captcha_error, setCaptcha_error] = useState(false);
  const [captcha_error_helper_text, setCaptcha_error_helper_text] =
    useState("");

  // Generate a random CAPTCHA text
  const generateCaptchaText = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let text = "";
    for (let i = 0; i < 6; i++) {
      text += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return text;
  };

  // Draw the CAPTCHA text on canvas
  const drawCaptcha = (text) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas

    // Set random font style and size
    ctx.font = "24px Arial";
    ctx.fillStyle = "#333";

    // Draw the text with some distortion
    ctx.setTransform(1, 0.3, Math.random() * 0.3, 1, 0, 0); // Distort the text
    ctx.fillText(text, 10, 30); // Draw text at a position
    ctx.setTransform(1, 0, 0, 1, 0, 0); // Reset transform

    // Optionally, add some random lines for complexity
    for (let i = 0; i < 4; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.strokeStyle = "#888";
      ctx.lineWidth = 1;
      ctx.stroke();
    }
  };

  // Initialize CAPTCHA when the component mounts
  useEffect(() => {
    refreshCaptcha();
  }, []);

  useEffect(() => {
    verifyCaptcha(userInput);
  }, [userInput]);

  // Generate new CAPTCHA text and draw it
  const refreshCaptcha = () => {
    const newCaptchaText = generateCaptchaText();
    setCaptchaText(newCaptchaText);
    drawCaptcha(newCaptchaText);
    setUserInput("");
    setIsVerified(false);
  };

  // Handle user input change
  const handleInputChange = (e) => {
    setUserInput(e.target.value);
  };

  // Verify if user input matches the CAPTCHA text
  const verifyCaptcha = (userInput) => {
    if (userInput && userInput === captchaText && captchaText) {
      setCaptcha_error_helper_text("");
      dispatch(setCaptcha(true));
      setCaptcha_error(false);
      // alert("CAPTCHA Verified!");
    } else {
      setCaptcha_error_helper_text("введите символы");
      dispatch(setCaptcha(false));
      setCaptcha_error(true);
    }
  };

  return (
    <>
      <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
        <div className="captcha">
          <canvas
            ref={canvasRef}
            width={110}
            height={60}
            style={{
              border: "1px solid #2B2B2B",
              color: "#000",
              backgroundColor: "#fff",
            }}
          ></canvas>
        </div>
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
        <Item>
          <But variant="outlined" onClick={refreshCaptcha}>
            Обновить
          </But>
        </Item>
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
        <Item>
          <TextField
            value={userInput}
            // sx={{ width: "100%" }}
            onChange={handleInputChange}
            onfo
            // id="last_name"
            label={captcha_error_helper_text}
            variant="outlined"
            error={captcha_error}
            slotProps={{ inputLabel: { shrink: true } }}
            // helperText={captcha_error_helper_text}
            required
            // sx={{
            //   width: "100px", // Минимальная ширина 200 пикселей
            //   "& .MuiInputBase-root": {
            //     // Селектор для корневого элемента внутри TextField
            //     minWidth: "100px", // Гарантируем, что ширина не станет меньше 100 пикселей
            //   },
            // }}
          />
        </Item>
      </Grid>
      {/* <input
        type="text"
        placeholder="Введите символы"
        value={userInput}
        onChange={handleInputChange}
      /> */}
      {/* <button onClick={verifyCaptcha}>Проверить</button>
      {isVerified && <p>Verified!</p>} */}
    </>
  );
};

export default Captcha;
